import * as React from 'react';
import {FormattedMessage, injectIntl} from 'react-intl';
import {DraftPeopleStatusOptions} from '@models/draftPeople';
import Search, {SearchInputType} from '@components/custom/Search';


interface SearchInputProps {
  search: (filter: object) => any;
  form: any;
  intl: any;
}

const SearchDraftsPeopleComponent: React.FC<SearchInputProps> = props => {
  const {search} = props;
  
  const inputs = [{
    name: "content_id",
    label: <FormattedMessage id="app.select_video" defaultMessage={`Select Video`}/>,
    type: SearchInputType.VIDEO,
    size: 12
  }, {
    name: "person_id",
    label: <FormattedMessage id="app.person" defaultMessage={`Person`}/>,
    type: SearchInputType.PERSON,
    size: 12
  }, {
    name: "person_role_id",
    label: <FormattedMessage id="app.role" defaultMessage={`Role`}/>,
    type: SearchInputType.PERSON_ROLE,
    size: 12
  }, {
    name: "status",
    label: <FormattedMessage id="app.status" defaultMessage={`Select Status`}/>,
    type: SearchInputType.SELECT,
    options: DraftPeopleStatusOptions,
    size: 12
  }];
  
  return <Search inputs={inputs} search={search}/>
};

export default SearchDraftsPeopleComponent;